export { default } from './PageCulturalOrganizations.vue'
